<template>
  <div class="offset">
    <el-input
      type="number"
      v-model.number="value.number"
      placeholder="please input number"
    >
    </el-input>
    <el-select v-model="value.unit" class="offset--unit">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      options: [
        { value: "px" },
        { value: "%" },
        { value: "rem" },
        { value: "em" },
      ],
    };
  },
  computed: {},
  watch: {
    value() {
      this.$emit("input", {
        number: this.value.number,
        unit: this.value.unit,
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.offset
  display: flex
  &--unit
    width: 100px
    margin-left: 8px
</style>
